import { render } from "./XIconSolidProjectorScreenChart.vue?vue&type=template&id=5a051775"
import script from "./XIconSolidProjectorScreenChart.vue?vue&type=script&lang=js"
export * from "./XIconSolidProjectorScreenChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidProjectorScreenChart.vue"]])

export default __exports__